// globally set interval constant to be used in AngularJS components
(window as unknown as { [index: string]: number })[
  'GRAPHQL_REFRESH_INTERVAL'
] = 2000;
